module.exports = __webpack_public_path__ + "img/error-color.4d10b14d.svg";